import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { getStreamingStatus } from "@/services/apiProposal";

export function useGetStreamingStatus(proposal_id, search_type) {
  return useQuery({
    queryKey: ["proposalStreaming", proposal_id, search_type],
    queryFn: () => getStreamingStatus(proposal_id, search_type),
    onError: (e) => {
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
      else toast.error(e.message);
    },
    structuralSharing: (oldData, newData) => {
      // Merge new server data with existing cache, prioritizing optimistic client data
      if (!oldData || !newData) return newData;
      return { ...oldData, ...newData };
    },
  });
}
